<template>
  <LoaderView v-if="!isLoggedIn" />
  <Inactive v-else-if="!isConfirmed" />
  <MesPreferences v-else-if="!hasInfo" />

  <div v-else class="consumer-space-layout">
    <!-- Burger menu bouton visible uniquement sur mobile -->
    <button class="burger-menu" @click="menuOpen = true">
      <font-awesome-icon :icon="['fas', 'bars']" />
    </button>

    <!-- Barre du haut (mobile only) -->
    <div class="topbar">
      <button class="burger-menu" @click="menuOpen = true">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </button>
    </div>

    <!-- Overlay (cliquable pour fermer le menu) -->
    <div v-if="menuOpen" class="overlay" @click="menuOpen = false"></div>

    <!-- Menu latéral -->
    <div class="consumer-space-navbar" :class="{ open: menuOpen }">
      <div class="navbar-header">
        <router-link to="/" @click="menuOpen = false">
          <img class="img-logo" src="../assets/app/logo-version-allongee-baseline-couleur.png" alt="Logo" />
        </router-link>
        <button class="close-menu" @click="menuOpen = false">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>

      <div class="consumer-space-name">Bienvenue {{ name }}</div>

      <div class="consumer-space-menu">
        <router-link v-if="hasPat" class="consumer-space-menu-item" to="/actualites-pat" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon icon-news" :icon="['fas', 'shopping-basket']" />
          Mes actualités locales
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <router-link class="consumer-space-menu-item" to="/mes-menus" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-weekly" :icon="['fas', 'utensils']" />
          Mes menus de la semaine
        </router-link>

        <router-link class="consumer-space-menu-item" to="/mes-idees-repas" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-ideas" :icon="['fas', 'lightbulb']" />
          Mes idées de repas personnalisés pour une journée
        </router-link>

        <router-link class="consumer-space-menu-item" to="/recettes/" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-catalog" :icon="['fas', 'book-open']" />
          Le catalogue des recettes
        </router-link>

        <router-link class="consumer-space-menu-item" to="/mes-plats-preferes" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-favorites" :icon="['fas', 'heart']" />
          Mes plats préférés
        </router-link>

        <router-link class="consumer-space-menu-item" to="/atelier-mealim/recette" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-analysis" :icon="['fas', 'chart-line']" />
          Analyser ma recette (MEALIM)
        </router-link>

        <router-link class="consumer-space-menu-item" to="/atelier-mealim" exact active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-workshops" :icon="['fas', 'brain']" />
          Le coin des Ateliers
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <router-link class="consumer-space-menu-item" to="/mode-demploi" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon icon-about" :icon="['fas', 'brain']" />
          Qu’est-ce que Mes Meilleurs Menus ?
        </router-link>

        <div class="consumer-space-menu-spacer"></div>

        <router-link class="consumer-space-menu-item" to="/mon-compte" active-class="active" @click="menuOpen = false">
          <font-awesome-icon class="icon icon-account" :icon="['fas', 'user']" />
          Mon compte
        </router-link>

        <router-link class="consumer-space-menu-item" to="/deconnection" active-class="active"
          @click="menuOpen = false">
          <font-awesome-icon class="icon icon-logout" :icon="['fas', 'sign-out-alt']" />
          Déconnexion
        </router-link>
      </div>
    </div>

    <router-view style="flex: 1;" />
  </div>
</template>

<script>
import { userState } from "@/utils/store";
import LoaderView from "@/components/LoaderView.vue";
import Inactive from "@/views/Inactive.vue";
import MesPreferences from "@/views/MesPreferences.vue";

export default {
  name: "ConsumerSpaceLayout",
  components: {
    LoaderView,
    Inactive,
    MesPreferences,
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    isStaff() {
      return userState.me?.is_staff ?? null;
    },
    name() {
      return userState.me?.consumer_account?.consumers?.[0]?.name ?? "";
    },
    isLoggedIn() {
      return userState.isLoggedIn();
    },
    isConfirmed() {
      return true;
    },
    hasInfo() {
      return true;
    },
    hasPat() {
      return userState.me?.has_pat === true;
    },
  },
  mounted() {
    if (!this.isLoggedIn) {
      userState.recoverAuth().catch(() => {
        // si tokens invalides => redirection login (évite écran blanc)
        this.$router.replace("/connection");
      });
    }
  },
};
</script>

<style scoped>
.icon-news { color: #7dc4b0; }
.icon-weekly { color: #98ca69; }
.icon-ideas { color: #f2c66d; }
.icon-catalog { color: #76b9d4; }
.icon-favorites { color: #e0a0b2; }
.icon-analysis { color: #8aa6ef; }
.icon-workshops { color: #c4a0dd; }
.icon-about { color: #b9c4a0; }
.icon-account { color: #e0bc8c; }
.icon-logout { color: #d49b8e; }
.consumer-space-layout {
  display: flex;
  flex: 1;
  position: relative;
}

.consumer-space-navbar {
  width: 260px;
  min-width: 260px;
  max-width: 260px;
  background: #192704;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 20;
  transition: transform 0.3s ease-in-out;

  /* ✅ scroll interne */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.consumer-space-name {
  font-family: "Amanise";
  font-weight: 500;
  font-size: 30px;
  padding: 10px;
  color: #77af24;
}

.consumer-space-menu {
  display: flex;
  flex-direction: column;
}

.consumer-space-menu-item {
  color: #9da5ae;
  text-decoration: none;
  font-size: 18px;
  padding: 7px 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1;
}

.consumer-space-menu-spacer {
  height: 20px;
}

.consumer-space-menu-item.active {
  color: #77af24;
}

.consumer-space-menu-item:hover {
  color: #77af24;
}

.img-logo {
  width: 100%;
}

.burger-menu {
  display: none;
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 30;
  background: none;
  border: none;
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
}

.close-menu {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  margin-left: auto;
  cursor: pointer;
}

.overlay {
  display: none;
}

@media (max-width: 768px) {
  .consumer-space-navbar {
    position: fixed;

    /* ✅ IMPORTANT : on se met sous la topbar */
    top: 50px;

    /* ✅ IMPORTANT : hauteur restante sous la topbar */
    height: calc(100vh - 50px);

    left: 0;
    transform: translateX(-100%);

    /* ✅ IMPORTANT : espace bas pour voir le dernier item */
    padding-bottom: calc(40px + env(safe-area-inset-bottom));
  }

  .consumer-space-navbar.open {
    transform: translateX(0);
  }

  .burger-menu {
    display: block;
  }

  .close-menu {
    display: block;
  }

  .overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.topbar {
  display: none;
}

/* Affichée uniquement sur mobile */
@media (max-width: 768px) {
  .topbar {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 15px;
    background-color: #192704;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 30;
  }

  .burger-menu {
    display: block;
    font-size: 24px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
  }

  .consumer-space-layout {
    padding-top: 50px;
  }
}
</style>

